import {NOMEFERMATA_START} from './nomeFermataStartTypes'

export const changeNomeFermataStart = nomeFermataStart => {
    return {
        type: NOMEFERMATA_START,
        load: nomeFermataStart
    }
}

export const selectNewNomeFermataStart = (nomeFermataStart) => {

    return (dispatch) => {
        dispatch(changeNomeFermataStart(nomeFermataStart))
    }

}